import { Chain } from '@ankr.com/chains-list';

import { AddToProjectButton } from 'modules/chains/components/AddToProjectButton';
import { ChainMenu } from 'modules/chains/components/ChainMenu';
import { ChainOverview } from 'modules/chains/components/ChainOverview';
import { ChainPageWidget } from 'modules/chains/components/ChainPageWidget';
import { MultichainDetails } from 'modules/chains/components/MultichainDetails';
import { useAuth } from 'modules/auth/hooks/useAuth';

interface AAPIEndpointsWidgetProps {
  chain: Chain;
}

export const AAPIEndpointsWidget = ({ chain }: AAPIEndpointsWidgetProps) => {
  const { isLoggedIn } = useAuth();

  return (
    <MultichainDetails
      Component={ChainPageWidget}
      chain={chain}
      hasEndpoints={!isLoggedIn}
    >
      <ChainOverview
        addToProjectButton={isLoggedIn && <AddToProjectButton chain={chain} />}
        chain={chain}
        chainMenu={<ChainMenu chain={chain} />}
      />
    </MultichainDetails>
  );
};
